// src/pages/StripeCheckoutWebViewScreen.jsx
import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../sass/pages/stripeCheckoutWebview.scss";

const StripeCheckoutWebViewScreen = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const checkoutUrl = useMemo(() => {
    // 1) Preferência: state vindo do navigate(...)
    const fromState = location.state?.checkoutUrl;

    // 2) Fallback: query param ?url=
    const params = new URLSearchParams(location.search);
    const fromQuery = params.get("url");

    return fromState || fromQuery || "";
  }, [location.state, location.search]);

  const [seconds, setSeconds] = useState(2);

  useEffect(() => {
    if (!checkoutUrl) return;

    // countdown simples + redirect
    const t1 = setInterval(() => setSeconds((s) => (s > 0 ? s - 1 : 0)), 1000);
    const t2 = setTimeout(() => {
      // redirect na mesma aba (menos bloqueios)
      window.location.assign(checkoutUrl);
    }, 900);

    return () => {
      clearInterval(t1);
      clearTimeout(t2);
    };
  }, [checkoutUrl]);

  const handleBack = () => navigate(-1);

  const handleOpenNow = () => {
    if (!checkoutUrl) return;
    window.location.assign(checkoutUrl);
  };

  if (!checkoutUrl) {
    return (
      <div className="stripewv-page">
        <header className="stripewv-header">
          <button className="stripewv-back" onClick={handleBack} type="button">
            ← Voltar
          </button>
          <h1 className="stripewv-title">Finalizar Pagamento</h1>
          <span style={{ width: 92 }} />
        </header>

        <div className="stripewv-card">
          <p className="stripewv-error">
            Checkout não informado. Volte e gere a sessão novamente.
          </p>
          <button className="stripewv-secondary" onClick={handleBack} type="button">
            Voltar
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="stripewv-page">
      <header className="stripewv-header">
        <button className="stripewv-back" onClick={handleBack} type="button">
          ← Voltar
        </button>
        <h1 className="stripewv-title">Finalizar Pagamento</h1>
        <span style={{ width: 92 }} />
      </header>

      <main className="stripewv-main">
        <div className="stripewv-card stripewv-card--info">
          <div className="stripewv-spinner" aria-hidden="true" />
          <h2 className="stripewv-h2">Redirecionando para o checkout…</h2>
          <p className="stripewv-p">
            Se não abrir automaticamente, clique no botão abaixo.
          </p>

          <button className="stripewv-primary" onClick={handleOpenNow} type="button">
            Abrir checkout agora
          </button>

          <p className="stripewv-muted">
            Tentativa automática em {seconds}s
          </p>
        </div>
      </main>
    </div>
  );
};

export default StripeCheckoutWebViewScreen;
